import { getDatabase } from '@src/firebase/configuration';


const firebaseDB =  ( () => {
    let vendorId = null,
        subscriberId = null ;

    //configuration:
    function setVendorId( val ){
        vendorId = val ;
    }
    function setSubscriberId( val ){
        subscriberId = val ;
    }
    //configuration

    //firebase paths:

    function getContentPath(){
        if( !vendorId ) throw new Error('firebase configuration error');
        this.context_ = {
            method: null,
            path: `${ vendorId }/content`,
            data: null
        }
        return this;
    }

    function getSubscriberPath(){
        if( !vendorId || !subscriberId ) throw new Error('firebase configuration error');
        this.context_ = {
            method: null,
            path: `${ vendorId }/subscriber/${ subscriberId }`,
            data: null
        }
        return this ;
    }

    //firebase paths

    //methods:

    function ref( relativePath = '' ){
        if( !this.context_ ) throw new Error('ref() called without accessing subscriber/content paths');
        
        this.context_.path += relativePath ;

        return this ;
    }

    function get() {
        if( !this.context_ ) throw new Error('assign path before calling get()');

        const context = this.context_ ;
        this.context_ = null ;

        context.method = 'get' ;

        return callDatabase_( context ) ;
    }

    function on( reference, callback ){
        if( !this.context_ ) throw new Error('assign path before calling on()');

        const context = this.context_ ;
        this.context_ = null ;

        context.method = 'on' ;
        context.reference = reference;
        context.callback = callback 

        return callDatabase_( context ) ;
    }
    function off( reference ){
        if( !this.context_ ) throw new Error('assign path before calling off()');

        const context = this.context_ ;
        this.context_ = null ;

        context.method = 'off' ;
        context.data = reference;

        return callDatabase_( context ) ;
    }


    function set( data = null ) {
        if( !this.context_ ) throw new Error('assign path before calling add()');

        const context = this.context_ ;
        this.context_ = null ;

        context.method = 'set' ;
        context.data = data ;

        console.log( context );

        return callDatabase_( context ) ;
    }

    function update( data = null ) {
        if( !this.context_ ) throw new Error('assign path before calling get()');

        const context = this.context_ ;
        this.context_ = null ;

        context.method = 'update' ;
        context.data = data ;

        return callDatabase_( context ) ;
    }

    //methods


    /**
     * 
     * @param { Object } context 
     * context includes:
     * path: db path to access at ref().
     * method: database method to call.
     * data: data to pass to the method.
     * 
     * @returns @promise which resolves once action is successful.
     */
    async function callDatabase_( context ){
        
        const database = await getDatabase() ;
        
        if( context.method === 'get' ) return (
            
            database.ref( context.path ).get().then( ( snapshot ) => {
                return snapshot.exists() ? snapshot.val() : null ;   
            } )    
        )

        if( context.method === 'on' ){
            database.ref( context.path ).off( context.reference ) ; //remove all previous listeners ;
            database.ref( context.path ).on( context.reference , ( snapshot ) => {
                const data = snapshot.exists() ? snapshot.val() : null ; 
                context.callback( data );

            } )
        }
        
        else return database.ref( context.path )[ context.method ]( context.data )
    }


    return {
        context_ : null ,
        setVendorId,
        setSubscriberId,
        getContentPath,
        getSubscriberPath,
        ref,
        get,
        set,
        update,
        on,
        off
    }


} )();

for( let methodname in firebaseDB ){
    let method = firebaseDB[ methodname ];
    if( method instanceof Function ) firebaseDB[ methodname ] = method.bind( firebaseDB );
}

export default firebaseDB ;